import React from 'react';
import { Dialog } from '@mui/material';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

const LoadingDialog = ({ open, handleClose }) => {
    const { t } = useTranslation();
    return (
        <Dialog
            onClose={handleClose}
            open={open}
            sx={{
                '& .MuiPaper-root': {
                    backgroundColor: '#00000000', // Custom background color
                    boxShadow: 'none',
                },
                backgroundColor: '#00000000',
                borderWidth: 0,
            }}
        >
            <Image
                width={50}
                height={50}
                src={'/loading.gif'}
                alt=""
                style={{ objectFit: 'cover' }}
            />
        </Dialog>
    );
};

export default LoadingDialog;
